import script from "./PaymentMethodList.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodList.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodList.vue?vue&type=style&index=0&id=3a976b33&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a976b33"]])

export default __exports__